import React, { useEffect, useState } from "react";
import {
  DashboardLayout,
  DeletePopupModal,
  PopupModal,
  FormParser,
} from "../Components";
import { NavLink, useNavigate, useSearchParams } from "react-router-dom";
import axiosConfig from "../Service/axiosConfig";
import { MdDeleteOutline, MdOutlineEdit } from "react-icons/md";
import { FaHandHoldingHeart } from "react-icons/fa";
import DataTable from "react-data-table-component";
import AlertDeletePopupModal from "../Components/PopupModal/AlertDeletePopupModal";
import "./master_categories.css";
import { Button, Modal } from "react-bootstrap";
import Masters from "../Components/masters.json";
import { BiSearch } from "react-icons/bi";
import useDebouncedValue from "../Utils/Debounce";
import CustomSelectProps from "../Components/CustomSelect/Customselect";
const Participants = () => {
  const MastersModal = Masters.Participants;
  const [searchParams, setSearchParams] = useSearchParams();
  const initialSearch = searchParams.get("search") || "";
  const [AlertDeletePopupType, SetAlertDeletePopupType] = useState("");
  const [deletePopupType, setDeletepopupType] = useState("");
  const [loading, setLoading] = useState(false);
  const [RowId, SetRowId] = useState();
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [RowPerPage, setRowPerPage] = useState(30);
  const [popupType, setpopupType] = useState("");
  const [show, setShow] = useState(false);
  const [modalTitle, setModalTitle] = useState("Add New Participant");
  const [message, setMessage] = useState("");

  const [options, setOptions] = useState([]); // State to store options
  const [selectedOption, setSelectedOption] = useState(null); // St
  const handleClose = () => {
    setShow(false);
    SetError("");
    setpopupType("");
  };
  const [Error, SetError] = useState("");
  const tableCustomStyles = {
    rows: {
      style: {},
    },
    cells: {
      style: {
        justifyContent: "center",
      },
    },
    headCells: {
      style: {
        color: "#5C5C5C",
        justifyContent: "center",
        color: "rgb(33,37,41)",
        fontSize: "12px",
        fontWeight: 500,
        lineHeight: "28px",
      },
    },
  };
  const handleShow = () => {
    setShow(true);
    setFormData({
      full_name: "",
      email: "",
      mobileno: "",
      address: "",
      map: "",
      latitude: "",
      longitude: "",
    });
    setModalTitle("Add New  Participant");
  };
  const [search, SetSearch] = useState({
    search: initialSearch,
  });
  const debouncedSearchTerm = useDebouncedValue(search.search, 500);
  const [Data, SetData] = useState([]);
  useEffect(() => {
    // Fetch options from API
    const fetchOptions = async () => {
      setLoading(true);
      try {
        const response = await axiosConfig.get("/accounts/course/");
        console.log(response.data, "res");
        const fetchedOptions = response.data?.results?.map((course) => ({
          value: course.id,
          label: course.name,
        }));
        setOptions(fetchedOptions);
      } catch (err) {
        SetError("Error fetching courses");
      } finally {
        setLoading(false);
      }
    };

    fetchOptions();
  }, []);
  const handleSelectChange = (options) => {
    setSelectedOption(options);
  };
  console.log(selectedOption?.value, "se");
  const GetData = async () => {
    setLoading(true);
    try {
      const responce = await axiosConfig.get(
        `/accounts/participant/?page=${currentPage}&page_size=${RowPerPage}&search=${debouncedSearchTerm}`
      );
      SetData(responce.data.results);
      setLoading(false);
      setTotalRows(responce.data.count);
    } catch (error) {
      console.log(error);
    }
  };
  const HandleSearch = (e) => {
    e.preventDefault();
    const full_name = e.target.full_name;
    const value = e.target.value;
    console.log(full_name, value);
    SetSearch({ ...search, [full_name]: value });
    if (value) {
      setSearchParams({ search: e.target.value });
    } else {
      setSearchParams();
    }
  };
  const handleSort = (column, direction) => {
    console.log(column.selector, direction);
    axiosConfig
      .get(
        `/accounts/participant/?page=${currentPage}&page_size=${RowPerPage}&ordering=${
          direction === "asc" ? column.selector : -column.selector
        }`
      )
      .then((res) => {
        SetData(res.data.results);
      })
      .catch((error) => {
        console.log(error);
      });
    setCurrentPage(1);
  };
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    mobileno: "",
    address: "",
    map: "",
    latitude: "",
    longitude: "",
  });

  const studentedit = (id) => {
    axiosConfig
      .get(`/accounts/participant/${id}/`)
      .then((res) => {
        console.log(res);
        setFormData({
          ...res.data,
          email: res.data?.user?.email,
          mobileno: res.data?.user?.mobileno,
          full_name: res.data?.user?.full_name,
          address: res.data?.user?.address,
          map: res.data?.map,
          latitude: res.data?.user?.latitude,
          longitude: res.data?.user?.longitude,
        });
        setShow(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    GetData();
  }, [currentPage, RowPerPage, debouncedSearchTerm, selectedOption?.value]);

  const formSubmit = (formData, setFieldErrors) => {
    console.log(formData);
    const formDataToSend = new FormData();
    formDataToSend.append("full_name", formData.full_name);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("mobileno", formData.mobileno);
    formDataToSend.append("address", formData.address);
    formDataToSend.append("map", formData.map);
    formDataToSend.append("latitude", formData.latitude);
    formDataToSend.append("longitude", formData.longitude);

    axiosConfig.defaults.headers["Content-Type"] = "multipart/form-data";
    if (formData.id) {
      axiosConfig
        .patch(`/accounts/participant/${formData.id}/`, formDataToSend)
        .then((res) => {
          console.log(res);
          setMessage("Participant Updated Successfully");
          setpopupType("success");
          GetData();
          setShow(false);
          SetError("");
        })
        .catch((error) => {
          let errorData = {};
          console.log(error);
          setpopupType("error");
          let error_message = error.response.data.error;
          Object.values(error_message) &&
            SetError(Object.values(error_message));
        });
    } else {
      axiosConfig
        .post("/accounts/participant/", formDataToSend)
        .then((res) => {
          console.log(res);
          setMessage("Participant Created Successfully");
          setpopupType("success");
          GetData();
          setShow(false);
          SetError("");
        })
        .catch((error) => {
          let errorData = {};
          console.log(errorData);
          setpopupType("error");
          let error_message = error.response.data.error;
          console.log(error_message);
          Object.values(error_message) &&
            SetError(Object.values(error_message));
        });
    }
  };

  const columns = [
    {
      name: "S.No",
      selector: "id",
      cell: (row, i) => (currentPage - 1) * RowPerPage + i + 1,
      sortable: true,
    },
    {
      name: "Full Name",
      selector: "full_name",
      cell: (row) => row.user?.full_name,
      sortable: true,
    },

    {
      name: "Email",
      selector: "email",
      cell: (row) => row.user?.email,
      sortable: true,
    },
    {
      name: "Mobile No",
      selector: "mobileno",
      cell: (row) => row.user?.mobileno,
      sortable: true,
    },
    {
      name: "Address",
      selector: "address",
      cell: (row) => row.user?.address,
      sortable: true,
    },

    {
      name: "ACTIONS",
      selector: (row) => {
        const HandleEdit = async () => {
          console.log(row.id, "iddddd");
          studentedit(row.id);
          setModalTitle("Edit Participants");
        };
        const handleRevive = async () => {
          try {
            const response = await axiosConfig.post(
              `/accounts/participant/${row.id}/revive/`
            );
            setpopupType("success");
            setMessage("Participant revived successfully");
            GetData();
          } catch (error) {
            console.log("Error While Reviving", error);
          }
        };
        const DeleteAlert = () => {
          SetRowId(row.id);
          SetAlertDeletePopupType("success");
        };
        const CancelAlerrt = () => {
          SetAlertDeletePopupType("error");
        };
        const HandleDelete = async (id) => {
          await axiosConfig
            .delete(`/accounts/participant/${id}/`)
            .then(() => {
              SetAlertDeletePopupType("error");
              setDeletepopupType("success");
              GetData();
            })
            .catch((error) => {
              setDeletepopupType("error");
              SetAlertDeletePopupType("error");
              console.log(error);
            });
        };
        return (
          <>
            {!row.is_suspended ? (
              <div className="row">
                <div className="col-3">
                  <MdOutlineEdit
                    className="dashboard-tabe-data-actions"
                    onClick={HandleEdit}
                  />
                </div>
                <div className="col-3">
                  <MdDeleteOutline
                    className="dashboard-tabe-data-actions"
                    onClick={DeleteAlert}
                  />
                </div>
              </div>
            ) : (
              <>
                <FaHandHoldingHeart
                  className="dashboard-tabe-data-actions"
                  onClick={handleRevive}
                />
              </>
            )}
            {AlertDeletePopupType === "success" && (
              <AlertDeletePopupModal
                AlertDeletePopupType={AlertDeletePopupType}
                HandleDelete={HandleDelete}
                CancelAlerrt={CancelAlerrt}
                row={RowId}
              />
            )}
          </>
        );
      },
    },
  ];
  return (
    <>
      <div className="childnav-content">
        <div className="d-flex align-items-center">
          {/* <div className="course-inputs">
            <CustomSelectProps
              placeholder="Course Name"
              options={options}
              value={selectedOption}
              onChange={handleSelectChange}
              isSearchable
            />
          </div> */}
          <div className="col-4 input-cat-with-icon">
            <span className="icon-product">
              <BiSearch />
            </span>
            <input
              type="text"
              className="input-control"
              placeholder="Search"
              name="search"
              value={search.search}
              onChange={HandleSearch}
            />
          </div>

          <div className="cat-button">
            <div className="btn" onClick={handleShow}>
              + Add New
            </div>
          </div>
        </div>
        <div
          className="table-responsive marginTop"
          style={{ overflow: "auto" }}
        >
          <DataTable
            columns={columns}
            data={Data}
            pagination
            paginationTotalRows={totalRows}
            paginationPerPage={RowPerPage}
            paginationDefaultPage={currentPage}
            onChangePage={(page) => setCurrentPage(page)}
            paginationPerPageOptions={[10, 20, 25, 30, 40, 50]}
            paginationRowsPerPageOptions={[10, 20, 25, 30, 40, 50]}
            onChangeRowsPerPage={(RowsPerPageChange) =>
              setRowPerPage(RowsPerPageChange)
            }
            onSort={handleSort}
            paginationServer
            fixedHeader
            fixedHeaderScrollHeight="800px"
            subHeader
            customStyles={tableCustomStyles}
            progressPending={loading}
            progressComponent={
              <div className="loader-container">
                <img
                  src={require("../Components/FormParser/images/loader2.gif")}
                  alt="Loading..."
                />
              </div>
            }
          />
        </div>
      </div>

      <Modal
        size="xl"
        show={show}
        onHide={handleClose}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            {modalTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormParser
            modelObject={MastersModal}
            formData={formData}
            formSubmit={formSubmit}
            buttonTitle="Save"
          />
        </Modal.Body>
      </Modal>

      {popupType != "" && (
        <PopupModal
          setpopupType={setpopupType}
          popupType={popupType}
          Navigation=""
          error={Error}
          Message={message}
        />
      )}
      {deletePopupType != "" && (
        <DeletePopupModal
          setDeletepopupType={setDeletepopupType}
          deletePopupType={deletePopupType}
        />
      )}
    </>
  );
};
export { Participants };
